import { Component } from '@angular/core';

@Component({
  selector: 'app-unauth-layout',
  templateUrl: './unauth-layout.component.html',
  styleUrls: ['./unauth-layout.component.scss']
})
export class UnauthLayoutComponent {
  popup = '';
  currentYear = new Date().getFullYear();

  openPopup(type: string): void { this.popup = type; }
  closePopup(): void { this.popup = ''; }
}
